import { Outlet } from 'react-router';

import { LayoutContainer } from '@/components/layout/container';
import { CookieContainer } from '@/components/layout/cookie-container';
import { LandingHeader } from '@/components/layout/landing/header';

export function LandingLayout() {
  return (
    <CookieContainer>
      <LayoutContainer>
        <LandingHeader />

        <main style={{ flex: 1 }}>
          <Outlet />
        </main>
      </LayoutContainer>
    </CookieContainer>
  );
}
